'use strict';

module.exports = [
  function () {
    return {
      template: require('./situationRecordTable.html'),
      controller: require('./situationRecordTableCtrl'),
      controllerAs: 'SRTCtrl',
      restrict: 'E',
      scope: {
        situationRecordList: '=',
        sourceList: '=',
        datex2Enums: '=',
        situationRecordTypesTree: '=',
        /**
         * activeId: se passato indica la riga da evidenziare come active
         */
        activeId: '=',
        curFilter: '=',
        // events
        situationRecordDeleted: '&onSituationRecordDeleted',
        situationRecordSelected: '&onSituationRecordSelected',
        situationRecordUpdated: '&onSituationRecordUpdated',
      },
    };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/directives/situationRecordTable/situationRecordTable.js
// module id = 268
// module chunks = 0